import { render } from "./ProductCategory.vue?vue&type=template&id=8de7cffe"
import script from "./ProductCategory.vue?vue&type=script&lang=js"
export * from "./ProductCategory.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__